// src/components/ConfirmDeleteModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const ConfirmDeleteModal = ({ show, onClose, onConfirm, message }) => {
  const { t } = useTranslation();
  
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header style={{ background: "#2B2F38", color: "#fff" }}>
        <Modal.Title>{t(`note.delete.title`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#2B2F38", color: "#fff" }}>
        {t(`note.delete.texte`)}
      </Modal.Body>
      <Modal.Footer style={{ background: "#2B2F38" }}>
        <Button variant="secondary" onClick={onClose}>
          {t(`note.delete.cancel`)}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {t(`note.delete.delete`)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
